import axios from "axios";

const state = () => ({
    dashboard: null,
    isBusy: false
})

// getters
const getters = {
    isBusy: state => state.isBusy,
    dashboard: state => state.dashboard,
}

// mutations
const mutations = {
    setBusy(state, data) {
        state.isBusy = data;
    },
    setDashboard(state, data) {
        state.dashboard = data;
    }
}

// actions
const actions = {
    // eslint-disable-next-line no-unused-vars
    getDashboard({state, commit, rootState}, data) {
        commit('setBusy', true);
        axios.get(`/api/dashboard/statistic`)
            .then(function (response) {
                commit('setDashboard', response.data);
            })
            .catch(error => {
                console.log(error);
            });
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
